export const getIntegrationWorkbooks = (workbooks: any[] | null, integrationId: string) => {
  /*
   * From a list of all workbooks available, return only those that are
   *   associated with the given integration.
   */
  return (workbooks || []).filter(w => w.integrationUid === integrationId);
}

export const getWorkbookViews = (views: any[] | null, integrationId: string, workbookId: string) => {
  /*
   * From a list of all views available, return only those that are
   *   associated with the given integration & workbook.
   */
  return (views || []).filter(v => v.integrationUid === integrationId && v.workbookId === workbookId);
}

export const getViewCustomViews = (customViews: any[] | null, integrationId: string, viewId: string) => {
  /*
   * From a list of all custom views available, return only those that are
   *   associated with the given integration & view.
   */
  return (customViews || []).filter(cv => cv.integrationUid === integrationId && cv.view_id === viewId);
}

export const tableauItemsToOptions = (items: any[]) => {
  return items?.map((item: any) => ({
    label: item.name,
    value: item.id,
    secondary_label: item.project_name,
  })) || [];
}

export const createDefaultOption = (label: string, value: string) => {
  /*
   * Only add default option if both label and value are present.
   */
  const option = {
    label,
    value,
    secondary_label: '',
  };

  if (!label || !value) {
    return [];
  }
  return [option];
}

export const createDefaultContent = (integrationId: string | null = null) => {
  return {
    integration_id: integrationId,
    workbook_id: '',
    view_id: '',
    thumbnail: '',
  };
}

export function updateEmbedUrlWithNewTicket(embedUrl: string, newTicket: string) {
  const trustedTicketPattern = /\/trusted\/([^/]+):([^/]+)\//;

  if (trustedTicketPattern.test(embedUrl)) {
    return embedUrl.replace(trustedTicketPattern, `/trusted/${newTicket}/`);
  } else {
    const viewsPattern = /\/views\//;
    if (viewsPattern.test(embedUrl)) {
      return embedUrl.replace(viewsPattern, `/trusted/${newTicket}/views/`);
    }
  }

  return embedUrl;
}

export function removeTrustedTicketFromUrl(embedUrl: string) {
  const trustedTicketPattern = /\/trusted\/[^/]+\//;
  return embedUrl.replace(trustedTicketPattern, '/');
}
